import { render, staticRenderFns } from "./DeadlineDeleteCheckBox.vue?vue&type=template&id=8c24e0a6&scoped=true"
import script from "./DeadlineDeleteCheckBox.vue?vue&type=script&lang=js"
export * from "./DeadlineDeleteCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c24e0a6",
  null
  
)

export default component.exports